import * as Yup from 'yup';
import type { InferType } from 'yup';

export type ContactFormData = InferType<typeof contactFormValidationSchema>;

export const contactFormValidationSchema = Yup.object({
  form_id: Yup.string().required('Form ID is required'),
  first_name: Yup.string().required('First name is required'),
  last_name: Yup.string().required('Surname is required'),
  person_title: Yup.string(),
  company_name: Yup.string(),
  phone_number: Yup.string().matches(
    /^(\+?[1]{1}[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, // Regex for typical US phone number
    'Phone number is not valid'
  ),
  user_email: Yup.string()
    .email('Invalid email address')
    .required('Email address is required'),
  contact_reason: Yup.string()
    .notOneOf(['default'], 'Contact reason must be selected')
    .required('Contact reason must be selected'),
  retailer_purchased_from: Yup.string().when('contact_reason', {
    is: 'Complaint',
    then: schema => schema,
    otherwise: schema => schema,
  }),
  bag_size: Yup.string().when('contact_reason', {
    is: 'Complaint',
    then: schema =>
      schema
        .notOneOf(['default'], 'Please select a bag size')
        .required('Please select a bag size'),
    otherwise: schema => schema,
  }),
  media_outlet: Yup.string().when('contact_reason', {
    is: 'Public Relations/Media',
    then: schema => schema.required('Please describe the Media Outlet'),
    otherwise: schema => schema,
  }),
  company_type: Yup.string().when('contact_reason', {
    is: 'Sales',
    then: schema =>
      schema
        .notOneOf(['default'], 'Please select a type of company')
        .required('Please select a type of company'),
    otherwise: schema => schema,
  }),
  message: Yup.string().max(5000, 'Too Long').required('Message is required'),
});
